import React, {useState, useEffect,  useRef} from 'react'
import {LoadEffect, TableLoader}  from '../component/loader'
import axios from 'axios'
import { Alerts, WarningModal } from '../component/notify'
import PageHeader from '../component/pageheader'
import { config,  API_URL, API_IMAGE} from '../component/include'
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import {Type} from 'react-bootstrap-table2-editor';
import paginationFactory from 'react-bootstrap-table2-paginator';

import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import TextEditor from '../api/editor'
import Error403 from '../settings/error403'

const Vacancy =()=> {
    const [notice, setNotice] = useState({
        isLoading : false,
        isDataFetching: false
    });

    const [job, setJob] = useState({
      position:'',
      description:'',
      close_date:''
    })

    const [content, setContent] = useState([])
    const [isSubmitting, setIsSubmitting] = useState(false); 
    const [errors, setErrors] = useState({});
    const [isAuthenticated, setIsAuthenticated] = useState(true);

    const ValidateInput =()=>{
      let errors = {};   
      if(!job.position){
        errors.position ='Please enter position.';
      }
      if(!job.description){
        errors.description ='Enter vacancy description';
      }

      if(!job.close_date){
        errors.close_date ='Enter closing date';
      }
         
      return errors;
      }



    const fetchContent =()=>{
      
      let url = API_URL+'/vacancy/display/all';
         axios.get(url, config).then(result=>{  
          if(Array.isArray(result.data.data)){
            
            let responseData = []
            let rs = result.data.data
            for (var i = 0; i< rs.length;  i++) {
              responseData.push(
                  { 
                    ...rs[i],
                    status:new Date(rs[i].expire_date)> new Date()?'Active':'Inactive',
                      
                  });
                  } 
                  setContent(responseData)
          }
        })
        .catch((error)=>{
            Alerts('Error!', 'danger', error.message)
        })
  }


  
  const handleEditorChange = (content, editor) => {
    setJob({...job, description : content });
      setErrors({...errors, description:''});
    }

    
    const handleChange = event =>{		
      let {name, value} = event.target;	
     
     setJob({...job, [name] : value });
      setErrors({...errors, [name]:''});
      }


    function submit(){  
      setNotice({...notice,  isLoading: true})     
         
        const fd = new FormData();

        for(let k in job){
          fd.append(k,job[k]);
      };
      
           let url = API_URL+'/vacancy/add';
          axios.post(url, fd, config)
          .then(response =>{
            if(response.data.status ===200){
              Alerts('Saved!', 'success', response.data.message);
                  } else{
              Alerts('Error!', 'danger', response.data.message)
                  }   
          })
          .catch((error)=>{
            Alerts('Error!', 'danger', error.message)
          }).finally(()=>{
              setNotice({...notice, isLoading: false  })

              setJob({
                position:'',
                description:'',
                close_date:''
              })
              setIsSubmitting(false);
              fetchContent()
          }) 
  }
  

  const handleSubmit = event =>{
    event.preventDefault();         
    setErrors(ValidateInput(content));
        setIsSubmitting(true);
  }
  
useEffect(()=>{
  if(Object.keys(errors).length === 0 && isSubmitting){
  submit()
  }
  },[errors, isSubmitting])

  useEffect(()=>{
   fetchContent()
   },[]);


const DataTable =(props)=>{
  const customTotal = (from, to, size) => (
    <span >&nbsp;Showing { from } to { to } of { size } entries</span>
  );

  
  const { SearchBar } = Search;
  const handleUpdate=(column, newValue, code)=>{       
    const fd = new FormData();
    fd.append('newValue', newValue);
    fd.append('column', column.dataField);
    fd.append('code', code);
    let url = API_URL+'/vacancy/change_field'
    axios.post(url, fd, config)
        //.then(result => console.log(result.data))
        .then()
        .catch((error)=>Alerts('Error!', 'danger', error.message))
        .finally(()=>{
            fetchContent()
        }) 
    } 
    const options = {
        showTotal: true,
    paginationTotalRenderer: customTotal,
    sizePerPageList: [{text: '20', value: 20}, {text: '50', value: 50}, {text: '100', value: 100}, {text: '500', value: 500}, { text: 'All', value: props.data.length }]
       
      };
 

  return <React.Fragment>  
 
          <ToolkitProvider keyField='code' data={ props.data } columns={ props.columns } >                  
                  {
                      props => ( 
                        <div >
                           <div className="form-group">
                             <SearchBar
                             { ...props.searchProps } style={{height:'40px'}} className="form-control" placeholder="Type to search!!!" />
                             &nbsp;

                             </div>                            
                        <BootstrapTable
                         { ...props.baseProps }
                                     striped
                                 hover
                                 condensed
                                 noDataIndication={<div className="alert alert-danger">No Record Found</div>}
                             pagination={paginationFactory(options) } 
                             cellEdit={ cellEditFactory({
                              mode: 'dbclick',
                              blurToSave: true,
                              autoSelectText: true,
                    beforeSaveCell: (oldValue, newValue, row, column) => {
                      if(oldValue !==newValue){
                      handleUpdate(column, newValue, row.code);                        
                     return props.fetchdata;
                    }                      
                  }
                         }
                         
                         ) }                              
                         />
                          </div>
                      )
                  }
</ToolkitProvider>
</React.Fragment>
}


const handleDelete =(code)=>{
  let close =   document.getElementById('btnWarningDialog-'+code)
  close.click();
 
  setNotice({...notice, 
      isLoading: true}) 

let url = API_URL+'/vacancy/delete/'+code;
    axios.get(url, config)
    .then(response =>{
     if(response.data.status ===200){
        Alerts('Saved!', 'default', response.data.message)
            } else{
        Alerts('Error!', 'danger', JSON.stringify(response.data))
            }   
    })
    .catch((error)=>{
      Alerts('Error!', 'danger', error.message)
    }).finally(()=>{
        fetchContent()
        setNotice({...notice, 
            isLoading: false
        })
    }) 
}






const tableHeader = [
    

  {dataField: 'position', text: 'Position',  validator: (newValue) => {
    if (!newValue) {
      return {
        valid: false,
        message: 'This field is required'
      };
    }
    return true;
  }, formatter:(cell)=><span style={{display:'block',  width:300, whiteSpace:'normal', wordWrap:'break-word' }} >{cell}</span>, editor: {
    type: Type.TEXTAREA}},
   
        {dataField: 'expire_date',  text: 'Expire Date', editor: {
          type: Type.DATE}},
      {dataField: 'status', text: 'Status', editable: false, formatter: (cell, row)=>row.status==='Active'?<span className="pcoded-badge label label-success">{cell}</span>: <span className="pcoded-badge label label-danger">{cell}</span>,editor: {
        type: Type.SELECT, options:[
          {value:'Active', label:'Active'}, 
          {value:'Inactive', label:'Inactive'}]
      }},


    {dataField: 'code', text: 'Action', formatter: (cell, row)=><div>  
        <a href="#!" data-toggle="modal"   data-target={`#warningdialog-${row.code}`} className='btn btn-danger btn-sm'    title="Delete"><i className="icofont icofont-delete-alt"></i></a>
<WarningModal message="This is very dangerous, you shouldn't do it! are you really really sure.?" handleAction={()=>handleDelete(row.code)} mID={row.code} /> 

        </div>, editable: false},  
 ];



        return (   <>
            <div  className="main-body">
            {isAuthenticated?   <div className="page-wrapper">
                          {notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" }
               
                 
                   {/* <!-- Page-header start --> */}

        <PageHeader title="Vacancy">
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-file"></i> </a>
                            </li>
                            <li className="breadcrumb-item"><a href="#!">General</a> </li>
                    <li className="breadcrumb-item"><a href="#!">Vacancy</a> </li>
                    </PageHeader>
{/* The Page Body start here */}
                <div className="page-body">


                {errors.successMessage?
<div className="alert alert-success background-success">
        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
            <i className=" fa fa-times text-white"></i>
        </button>
        <strong> {errors.successMessage}</strong> 
    </div>:''}

{errors.errorMessage?
<div className="alert alert-danger background-danger">
        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
            <i className=" fa fa-times text-white"></i>
        </button>
        <strong> {errors.errorMessage}</strong> 
    </div>:''}

         
                <div  className="row  ">   
<div className="col-sm-12">                                 
<div className="card z-depth-0">
            <div className="card-header">
                <h5><i className="fa fa-th" ></i> Add Position</h5>
                <div className="card-header-right">
                    <ul className="list-unstyled card-option">
                        <li><i className="feather icon-maximizes full-card"></i></li>
                        <li><i className="feather icon-minus minimize-card"></i></li>
                        <li><i className="feather icon-trash-2 close-card"></i></li>
                    </ul>
                </div>
            </div>
            <div className="card-block">
            
            <div className="row  ">
							

	<div className="col-sm-12">

        <div className="card z-depth-0" >

		<div  className="card-block">
		
        <div className="row">
        <section className="col-md-12">
   

   <div className="form-group">
<label className='text-bold'>Job Position</label>

<input type="text" name="position" onChange={handleChange} 
value={job.position} className={errors.position? 'form-control form-control-danger' : 'form-control'} /> 

<span style={{color:'red'}}>{errors.position&& errors.position}</span>
   </div>

</section>

  <section className="col-md-12">
   

   <div className="form-group">
<label className='text-bold'>Description </label>

<div style={{ width: '100%'}}> 
                
				<TextEditor
					height={300}
					
					value={job.description}
					onEditorChange={handleEditorChange}        
				  /> 
		  
						</div>

<span style={{color:'red'}}>{errors.description && errors.description}</span>
   </div>



   <div className="form-group">
<label className='text-bold'>Close Date</label>

<input type="date" name="close_date" onChange={handleChange} 
value={job.close_date} className={errors.close_date? 'form-control form-control-danger' : 'form-control'} /> 

<span style={{color:'red'}}>{errors.close_date&& errors.close_date}</span>
   </div>

</section>

</div>
      

<hr/>

   <footer className="pull-right">
   
   <button type="button" className="btn btn-inverse " ><i className="fa fa-refresh"></i> Back</button>&nbsp;&nbsp;
   <button type="button" id="submit" onClick={handleSubmit}  className="btn btn-success "><i className="fa fa-save"></i> Save</button>
            </footer>
 </div> 
			
 </div>
                    </div>
                      </div>
                    </div></div>					
           </div>
                            
       </div>


                <div className="row  ">

	<div className="col-sm-12">
      
	<div className="card z-depth-0">
		<div className="card-header">
			<h5> <i className="fa fa-th" ></i> Vacancy</h5>
			<div className="card-header-right">
				<ul className="list-unstyled card-option">
					<li><i className="feather icon-maximizes full-card"></i></li>
					<li><i className="feather icon-minus minimize-card"></i></li>
					<li><i className="feather icon-trash-2 close-card"></i></li>
				</ul>
			</div>
		</div>
		<div className="card-block">
		<div className="col-md-12">
        <div className="table-responsive">

        {notice.isDataFetching ? <TableLoader />:
  <DataTable data={content} columns={tableHeader}  />} 

    </div></div></div>
</div>


</div>

</div>
	

   </div>
          {/* The Page Body close here */}

            </div>:
            <Error403 />}
            </div>

</> 
 );
        
}

export default React.memo(Vacancy) 